import BodyAll from './BodyAll';
import Filter  from './Filter' ;
import Body    from './Body'   ;

type Props = {
  BodyAll: typeof BodyAll;
  Filter : typeof Filter ;
  Body   : typeof Body   ;
}

const FactorsNeedpay2CompanyComponent: Props = {
  BodyAll,
  Filter ,
  Body   ,
}

export default FactorsNeedpay2CompanyComponent;
